<template>
  <tbody class="font-inter text-sm font-normal text-primary-gray-600 divide-primary-gray-200">
    <slot />
  </tbody>
</template>
